import React, { useEffect, useState } from 'react';
import Editor from '@monaco-editor/react'
import {
    Box,
    Text,
    VStack,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    CloseButton,
    Button,
    HStack,
    Spinner
} from '@chakra-ui/react';

import LuaEditor from './LuaEditor';
import LuaScriptAddForm from './LuaScriptAddForm';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLuaScripts } from '../actions/luaAction';

const LuaScriptList = () => {

    const dispatch = useDispatch();
    const { scripts, loading, error } = useSelector((state) => state.luaScripts);

    const [tabs, setTabs] = useState([]); // { id, name }
    const [activeTabIndex, setActiveTabIndex] = useState(0);

    const [showForm, setShowForm] = useState(false);

    const handleNewScript = () => {
        setShowForm(true);
    };

    const handleCloseForm = () => {
        setShowForm(false);
    };


    const openTab = (script) => {
        const exists = tabs.find((tab) => tab.id === script._id);
        if (!exists) {
            setTabs((prev) => [...prev, { id: script._id, name: script.name, script: script.script }]);
            setActiveTabIndex(tabs.length); // Focus newly opened tab
        } else {
            const index = tabs.findIndex((t) => t.id === script._id);
            setActiveTabIndex(index);
        }
    };

    const closeTab = (indexToClose) => {
        const newTabs = tabs.filter((_, i) => i !== indexToClose);
        setTabs(newTabs);
        if (activeTabIndex >= indexToClose) {
            setActiveTabIndex((prev) => Math.max(prev - 1, 0));
        }
    };



    useEffect(() => {
        dispatch(fetchLuaScripts());
    }, [dispatch]);

    if (loading) return <Spinner />;

    return (
        <Box display="flex" height="100vh">
            {/* Sidebar */}
            <VStack
                w="250px"
                spacing={4}
                align="stretch"
                p={4}
                bg="gray.50"
                borderRight="1px solid"
                borderColor="gray.200"
            >
                <Text fontSize="lg" fontWeight="bold">
                    Scripts  <Button mt={4} colorScheme="blue" onClick={handleNewScript}> New Script </Button>
                </Text>
                {scripts.map((script) => (
                    <Text
                        key={script._id}
                        onClick={() => openTab(script)}
                        cursor="pointer"
                        _hover={{ color: 'blue.500' }}
                    >
                        {script.name}
                    </Text>
                ))}
            </VStack>

            {/* IDE Tabs */}
            <Box flex="1" p={4}>
                <Tabs
                    index={activeTabIndex}
                    onChange={(index) => setActiveTabIndex(index)}
                    isFitted
                    variant="enclosed"
                >
                    <TabList>
                        {tabs.map((tab, index) => (
                            <Tab key={tab.id}>
                                <HStack spacing={1}>
                                    <Text isTruncated maxW="100px">
                                        {tab.name}
                                    </Text>
                                    <CloseButton
                                        size="sm"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            closeTab(index);
                                        }}
                                    />
                                </HStack>
                            </Tab>
                        ))}
                    </TabList>

                    <TabPanels>
                        {tabs.map((tab) => (
                            <TabPanel key={tab.id}>
                                <LuaEditor luaSID={tab.id} luaScriptTxt={tab.script} />
                            </TabPanel>
                        ))}
                    </TabPanels>
                </Tabs>
                {showForm && (
                    <div style={{ marginTop: '20px' }}>
                        <LuaScriptAddForm onClose={handleCloseForm} />
                    </div>
                )}
            </Box>
        </Box>
    );
};

export default LuaScriptList;